import React, { useEffect, useState } from 'react';

interface EnhancedMessageProps {
  content: string;
  role: 'user' | 'assistant';
  isStreaming?: boolean;
  animateIn?: boolean; // Optional fade-in control
}

const Typewriter: React.FC<{ text: string }> = ({ text }) => {
  const [displayed, setDisplayed] = useState('');
  useEffect(() => {
    setDisplayed('');
    if (!text) return;
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) clearInterval(interval);
    }, 8);
    return () => clearInterval(interval);
  }, [text]);
  return <span>{displayed}</span>;
};

const EnhancedMessage: React.FC<EnhancedMessageProps> = ({
  content,
  role,
  isStreaming = false,
  animateIn = true,
}) => {
  // Comprehensive text cleanup to remove undefined, null, and fix spacing issues
  const cleanedContent = content
    .replace(/undefined|null/g, '')
    .replace(/\s+\?/g, '?')
    .replace(/\s+\./g, '.')
    .replace(/\s+,/g, ',')
    .replace(/\s+!/g, '!')
    .replace(/\s+:/g, ':')
    .replace(/\s+;/g, ';')
    .replace(/\s+/g, ' ')
    .trim();

  if (role === 'assistant') {
    return (
      <div
        className="font-inter text-base text-blue-700 whitespace-pre-line"
        style={{
          opacity: animateIn ? 1 : 0,
          transition: 'opacity 0.7s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        {animateIn ? (isStreaming ? cleanedContent : <Typewriter text={cleanedContent} />) : null}
      </div>
    );
  }
  return (
    <div className="font-inter text-base text-gray-900 whitespace-pre-line">
      {cleanedContent}
    </div>
  );
};

export default EnhancedMessage; 